import { DiagnosisListPage } from '@/features/features/diagnosis/components/List'
export default DiagnosisListPage
